// extracted by mini-css-extract-plugin
export default {"checkboxItem":"styles_checkboxItem__UkgGL","block":"styles_block__QS73T"};